import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Logo from '../../assets/img/logo.png'
// import PinMarker from '../../assets/img/map-icon.svg'
import URL from '../../constants/urls'
function NavbarComponent() {

	const { pathname } = useLocation()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [pathname])

	return (
		<header className="border-bottom"  >
			<nav className="navbar navbar-expand-lg">
				<div className="container">
					<Link
						to={URL.HOME}
					>
						<img src={Logo} width="60px" alt="mapco" />
					</Link>
					<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
						<span className="navbar-toggler-icon"></span>
					</button>
					<div className="collapse navbar-collapse" id="navbarNavDropdown">
						<ul className="navbar-nav ms-auto">

							{/* <li className="nav-item dropdown "> */}
							{/* <Link
									to={URL.HOME}
									className="nav-link dropdown-toggle"
									role="button" 
									data-bs-toggle="dropdown" 
									aria-expanded="false"
								>
                  Where To Park
								</Link>
								<ul className="dropdown-menu">
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Action
										</Link>
									</li>
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Another Action
										</Link>
									</li>
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Something Else Here
										</Link>
									</li>
								</ul>
							</li>
							<li className="nav-item dropdown ">
								<Link
									to={URL.HOME}
									className="nav-link dropdown-toggle"
									role="button" 
									data-bs-toggle="dropdown" 
									aria-expanded="false"
								>
                  Monthly Parking
								</Link>
								<ul className="dropdown-menu">
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Action
										</Link>
									</li>
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Another Action
										</Link>
									</li>
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Something Else Here
										</Link>
									</li>
								</ul>
							</li>
							<li className="nav-item dropdown ">
								<Link
									to={URL.HOME}
									className="nav-link dropdown-toggle"
									role="button" 
									data-bs-toggle="dropdown" 
									aria-expanded="false"
								>
                AutoPay Machines
								</Link>
								<ul className="dropdown-menu">
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Action
										</Link>
									</li>
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Another Action
										</Link>
									</li>
									<li>
										<Link
											to={URL.HOME}
											className="nav-link dropdown-item"
										>
                      Something Else Here
										</Link>
									</li>
								</ul>
							</li> */}
							<li className="nav-item ">
								<a
									href='https://www.mapcoparking.com/about/'
									target='_blank'
									className="nav-link" rel="noreferrer"
								>  About Us
								</a>
							</li>
							<li className="nav-item ">
								<a
									href='https://www.mapcoparking.com/contact/'
									target='_blank'
									className="nav-link" rel="noreferrer"
								>Contact Us
								</a>
							</li>
							<li className="nav-item ">
								<Link
									to={URL.RECOVER_TICKET}
									className="nav-link btn btn-light px-3" rel="noreferrer"
								> <i className='fas fa-download me-2 '></i> Download Ticket
								</Link>
							</li>
							{/* <li className="nav-item">
								<Link
									to={URL.HOME}
									className="nav-link"
								>
									<img src={PinMarker} alt="PinMarker"/>
								</Link>
							</li> */}
						</ul>
					</div>
				</div>
			</nav>
		</header>
	)
}
export default NavbarComponent
